var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{attrs:{"index":"/smart_cards"}},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":require("@src/assets/sidebar/smart-card-icon.svg")}})]),_c('router-link',{staticClass:"sub-menu-link",attrs:{"to":"/smart_cards"}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('sidebar.smart_cards')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }